<template>
    <div 
        :class="`story-maker-post-creator ${cursorName}`" 
        :style="{ fontSize: fontSize + 'px' }" 
        ref="story-maker"
    >   
        <div class="lock" v-if="previewEnabled"  @click="toggleMuteSound"></div>
        <div 
            class="overflow" 
            :class="{axeX:showAxe.x, axeY:showAxe.y}" 
            :style="{'--z-index-axe': showAxe.index, backgroundColor : storySelected.background.color}"
           
        >
 
        
            <alert 
                v-if="storySelected.removed"
                title="Démasquer la story ?" subTitle="Si vous démasquer cette story, elle apparaîtra lors de la publication sur la page sélectionnée." 
                :choices="[
                    {content:'Démasquer', warning: true, cb:()=> storySelected.removed = false},
                ]"
            />

            <alert 
                v-else-if="
                    showAlertDelete &&
                    formInstance.merge.target == 'main' &&
                    formInstance.stories.length == 1
                "
                title="Réinitialiser la story ?" subTitle="Si vous réinitialiser cette story, vous perdrez toutes les modification que vous avez apportées" 
                :choices="[
                    {content:'Réinitialiser', warning: true, cb: handleResetStory},
                    {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                ]"
            />

            <alert v-else-if="
                    showAlertDelete &&
                    (
                        formInstance.merge.target == 'main' ||
                        storySelected.fromPersonalisation
                    )
                "
                title="Supprimer la story ?" subTitle="Si vous supprimer cette story, vous perdrez toutes les modification que vous avez apportées" 
                :choices="[
                    {content:'Supprimer', warning: true, cb: handleDeleteStory},
                    {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                ]"
            />
            

            <alert
                v-else-if="
                    showAlertDelete &&
                    formInstance.merge.target.id &&
                    !storySelected.fromPersonalisation
                "
                title="Masquer la story ?" subTitle="Si vous masquez cette story, elle n’apparaîtra pas lors de la publication sur la page sélectionnée." 
                :choices="[
                    {content:'Masquer', warning: true, cb: handleDeleteStory},
                    {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                ]"
            />


            <template v-if="!overlayMode && !previewEnabled">
                <div class="btns-action" data-html2canvas-ignore="true">
                    <div class="btn sound" v-if="musicSticker || (backgroundFile && backgroundFile.info.type2 == 'video')" :class="{'muted':mutedSound}" @click="toggleMuteSound"></div>

                    <ButtonHighlight 
                        v-if="formInstance.merge.target.id && formInstance.merge.target.isNative"
                        :storySelected="storySelected" 
                        :formInstance="formInstance"
                        @click="setOverlay('highlight')"
                    />

                    <div class="btn text" @click="addText">
                        <img :src="require('@/assets/img/instagram/icon_story_text.png')">
                    </div>
                    <div class="btn stickers" @click="setOverlay('stickers')">
                        <img :src="require('@/assets/img/instagram/icon_story_sticker.png')">
                    </div>

                    <Tooltip
                        v-if="pagesSelectedIncludeConciergerie"
                        @click="() => { musicSticker ? this.stickerSelected = musicSticker : setOverlay('stickers-musicMenu')}"
                        :active="!!musicSticker" 
                        :text="!!musicSticker && (musicSticker.data.music.track ? musicSticker.data.music.track.title : musicSticker.data.music.original_sound.title)" 
                        position="bottom"
                        classCustom="btn music"
                    >
                        <img v-if="musicSticker" class="thumbnail-music" :src="musicSticker.data.music.track ? musicSticker.data.music.track.cover_artwork_thumbnail_uri : musicSticker.data.music.original_sound.ig_artist.profile_pic_url">
                        <img v-else :src="require('@/assets/img/instagram/icon_story_music.png')">
                    </Tooltip>
                  
                </div>
                
                <div class="btn delete-story" @click="handleDeleteStory" data-html2canvas-ignore="true">
                    <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                </div>

            </template>

            <div v-else-if="!previewEnabled && overlayMode && (overlayMode.slice(0,8) == 'stickers' || overlayMode == 'backgroundResize')" class="btns-action">
                <div class="btn cancel" @click="closeOverlay">
                    <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                </div>
            </div>

            <div class="btn-background-resize" v-if="overlayMode == 'backgroundResize' && storySelected.background.file">
                <template v-if="storySelected.background.file.info.aspectRatio > 0.5625">
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(45deg);" @click="storySelected.background.setSize('containX')"></i>
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"  @click="storySelected.background.setSize('containY')"></i>
                </template>
                <template v-else>
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(135deg);" @click="storySelected.background.setSize('containY')"></i>
                    <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"  @click="storySelected.background.setSize('containX')"></i>
                </template>  
            </div>
            
            <div class="trash-stiker" v-if="onStickerDrag" @mouseover="trashIsHover = true" @mouseleave="trashIsHover = false" :class="{active : trashIsHover}">
                <div class="icon"></div>       
            </div>

            <div class="container-bg-story" :class="{edit:overlayMode == 'backgroundResize'}">
                <draggable 
                    :position="storySelected.background.position" 
                    :transform="storySelected.background.transform" 
                    :classCustom="storySelected.background.size"
                    :disableTransform="overlayMode !== 'backgroundResize'" 
                    :disableMove="overlayMode !== 'backgroundResize'" 
                    @setStoryMakerCursor="setCursor"
                >
                    <div class="bg-story selectDisable" :class="storySelected.background.size">
                        <template v-if="storySelected.background.file">
                            <img  v-if="storySelected.background.file.info.type.startsWith('image/')" class="selectDisable" :src="storySelected.background.file.url"  draggable="false">
                            <video 
                                v-else-if="storySelected.background.file.info.type.startsWith('video/')" 
                                :src="storySelected.background.file.url" 
                                :type="storySelected.background.file.info.type" 
                                @timeupdate="videoCheckLoop"
                                onloadedmetadata="true"
                                preload="metadata" 
                                class="source" 
                                ref="video"
                                :muted="mutedSound || musicSticker"
                                autoplay loop playsinline
                            ></video>
                        </template>  
                    </div>
                </draggable>

            </div>
            <template v-if="overlayMode !== 'backgroundResize'">
                <draggable
                    v-for="(sticker, index) in storySelected.stickers.items"
                    :key="sticker.id"
                    :position="sticker.position" 
                    :transform="sticker.transform" 
                    :zIndex="100+index"
                    :classCustom="`story-maker-draggable-sticker ${sticker.type} id-${index} ${sticker.data.text}`"
                    :isSelected="stickerSelected && stickerSelected.id == sticker.id"
                    @deleteSticker="sticker.delete"
                    @increaseZIndex="sticker.bringToFront"
                    @click="()=>selectSticker(sticker)"
                    :disableTransform="sticker.disableTransform" 
                    :disableMove="sticker.disableMove" 
                    :disableDelete="sticker.disableDelete"
                    :disableIncreaseZIndex="sticker.disableIncreaseZIndex" 
                    :trashIsHover="trashIsHover"
                    @setDragState="(state)=>{onStickerDrag = state; trashIsHover = false}"
                    @setStoryMakerCursor="setCursor"
                    @setShowAxe="setShowAxe"
                >
                    <template v-slot="{ setCover, setCbClick, isPreventCover , isCover }">
                        <stickerWrapper
                            :sticker="sticker"
                            :isPreventCover="isPreventCover"
                            :isCover="isCover"
                            :setCover="setCover"
                            :setCbClick="setCbClick"
                            :files="files"
                            :previewEnabled="previewEnabled"
                            :pageSelected="pageSelected"
                            
        
                        

                            :stickerInstance="sticker"
                            :story="storySelected"
                            :isSelected="stickerSelected && stickerSelected.id == sticker.id"
                            @unselect="unselectSticker"
                            @select="selectSticker(sticker)"
                            @deleteSticker="sticker.delete"
                    
                        />
                    </template>
                </draggable>
            </template>

            <StickerMenu 
                v-if="overlayMode && overlayMode.split('-')[0] == 'stickers'" 
                :menuNameDefault="overlayMode.split('-')[1]" 
                :dataInstagramDefault="dataInstagramDefault" 
                :stickers="storySelected.stickers"
                :pagesSelectedIncludeConciergerie="pagesSelectedIncludeConciergerie"
                @addSticker="addSticker" 
                @close="closeOverlay"
            />
            <HighlightMenu 
                v-else-if="overlayMode && overlayMode == 'highlight'" 
                :formInstance="formInstance"
                :storySelected="storySelected"
                :highlights="highlightsPage[pageSelected.id] ? highlightsPage[pageSelected.id] : null" 
                :files="files"
                @close="closeOverlay"
            />
        </div>



         <audio 
            v-if="musicSticker" 
            @loadedmetadata="setStartMusic"
            @timeupdate="checkTimeMusic"
            :src="(musicSticker.data.music.track || musicSticker.data.music.original_sound).fast_start_progressive_download_url" 
            autoplay
            loop
            @canplaythrough="(e) => e.target.volume = mutedSound ? '0' : '0.5'"
            ref="audio"
            >
        </audio>

        <div 
            v-if="
                previewEnabled && 
                (musicSticker || (backgroundFile && backgroundFile.info.type2 == 'video'))
            " 
            :key="mutedSound ? 'no-sound' : 'sound'" 
            :class="mutedSound ? 'no-sound' : 'sound'"
        ></div>
    </div>
</template>



<script>
    import { EventBus } from '@/event-bus';
    import StickerMenu from './storyMaker/stickerMenu/main.vue';
    import HighlightMenu from './storyMaker/highlightMenu.vue'
    import draggable from './storyMaker/draggable.vue';
    import stickerWrapper from './storyMaker/stiker/stickerWrapper.vue';
    import { stickerDataDefault } from './storyMaker/stickerMenu/main.vue';
    import minxinPost from '@/components/mixins/Posts.vue'
    import mixinBot from '@/components/mixins/Bots.vue'
    import alert from './storyMaker/alert.vue';
    import { formDataDefault } from './../../constante.js';
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import { VueDraft } from '@mashupweb/draft-lib';
    import { Story } from '@mashupweb/draft-lib/dist/form/story/entities/story';
    import StoryForm from '@mashupweb/draft-lib/dist/form/story/Form';

    import ButtonHighlight from './storyMaker/buttons/highlight.vue'
    
    export default {

        mixins: [minxinPost, mixinBot],
        components: {
            StickerMenu,
            HighlightMenu,
            draggable,
            stickerWrapper,  
            alert,
            Tooltip,
            ButtonHighlight
        },

        props: {
            formData :  Object,
            saveAllFormData :  Object,
            idStorySelected: {
                type: String,
                default: '0'
            },
            pageSelected: {
                type: Object,
                default: false
            },

            previewEnabled: {
                type: Boolean,
                default: false
            },
            deleteStory: Function,
            files:Object,

            storySelected:Story,
            formInstance: StoryForm,
        },

        data() {
            return {
              
              
                overlayMode: false,
                cursorName: '',
                onStickerDrag: false,
                trashIsHover: false,
                showAxe: {
                    y:false,
                    x:false,
                    index: -1
                },
                showAlertDelete : false,
                resizeObserver: null,
                fontSize: 0,
                highlightsPage: {},
                mutedSound: true,
                stickerSelected: null,
            }
        },

        mounted () {

            if (!this.previewEnabled) this.getDataInstagramDefault();
            EventBus.$on('storyMaker-setOverlay', this.setOverlay);

            this.resizeObserver = new ResizeObserver(() => {
                this.updateFontSize();
            });
            this.resizeObserver.observe(this.$refs['story-maker']);
            this.updateFontSize();
        },

        methods: {
            selectSticker(sticker) {
                const notSelectedSticker = ['location', 'gif', 'link', 'image', 'post']
                if (notSelectedSticker.includes(sticker.type)) return
                this.stickerSelected = sticker
            },
            unselectSticker() {
                this.stickerSelected = null
            },

            handleDeleteStory() {
                if (!this.showAlertDelete) {
                    this.showAlertDelete = true
                    return
                }
                this.deleteStory()
                this.showAlertDelete = false
            },
            handleResetStory() {
                this.storySelected.reset()
                this.showAlertDelete = false
            },

            addSticker(sticker) {
               
                if (['survey', 'slider', 'hashtag'].includes(sticker.type)) {
                    const existingStickers = this.storySelected.stickers.getByType(sticker.type);
                    if (existingStickers.length) {
                        existingStickers[0].isEditing = true;
                        existingStickers[0].data = {...existingStickers[0].data, ...sticker.data};
                        return
                    }
                }

                this.selectSticker(
                    this.storySelected.stickers.new(sticker)
                )
            },

            setCursor(cursorName) {
                this.cursorName = cursorName
            },

            setShowAxe(axe, bool) {
                this.$set(this.showAxe, axe, bool)
            },

            setOverlay(name) {
                this.overlayMode = name
                if (name == 'highlight') {
                    this.loadHighlights(this.pageSelected.id)
                }
            },

            closeOverlay() { 
                this.overlayMode = false
            },

            async getDataInstagramDefault() {
                let page = this.pagesSelected.find(p => p.story_config && p.story_config.created && p.network == 'instagram')
                
                const data = {}

                if (page) {
                    //GIF
                   
                    if (!this.dataInstagramDefault.gifs.length) {
                        try {
                            const gifsResponse = (await this.getTrendGifsInstagram(page.id)).body.gifs.results.giphy
                            if (Array.isArray(gifsResponse) && gifsResponse.length) data.gifs = gifsResponse
                            console.log("getDataInstagramDefault", data.gifs)
                        } catch (error) {
                            console.log("getDataInstagramDefault error", error)
                        }
                    }
                    
                    //music
                    if (!this.dataInstagramDefault.musics.forYou.length || !this.dataInstagramDefault.musics.topTrends.length) {
                        data.musics = this.dataInstagramDefault.musics;
                        try {
                            if (!this.dataInstagramDefault.musics.forYou.length) {
                                const musicsReponse = (await this.getTrendMusicInstagram(page.id)).body.musics
                                if (Array.isArray(musicsReponse) && musicsReponse.length) data.musics.forYou = musicsReponse
                            }
                            if (!this.dataInstagramDefault.musics.topTrends.length) {
                                const musicsReponse = (await this.getTrendMusicInstagram(page.id, "topTrends")).body.musics
                                if (Array.isArray(musicsReponse) && musicsReponse.length) data.musics.topTrends = musicsReponse
                            }
                        } catch (error) {
                        }
                    }

                    //location 
                    if (!this.dataInstagramDefault.locations.length) {
                        try {
                            const locationsResponse = (await this.getLocation(page.id, 'france')).body.locations
                            if (Array.isArray(locationsResponse) && locationsResponse.length) data.locations = locationsResponse
                        } catch (error) {
                        }
                    }

                    //shops
                    if (!this.dataInstagramDefault.shops.length) {
                        try {
                            const shopsResponse = (await this.getTrendShopsInstagram(page.id)).body.shops
                            if (Array.isArray(shopsResponse) && shopsResponse.length) data.shops = shopsResponse
                        } catch (error) {
                        }
                    }

                    this.$store.commit('postCreator/updateDataStoryMakerDefault', data);
                } 
            },
            
            addText() {
                this.addSticker({...JSON.parse(JSON.stringify(stickerDataDefault['text']))})
            },


            updateFontSize() {
                console.log('updateFontSize',this.$refs['story-maker'], this.$refs['story-maker'].offsetWidth)
                const phoneWidth = this.$refs['story-maker'].offsetWidth;
                this.fontSize = phoneWidth;
            },

            async loadHighlights(pageId) {
                if (!this.previewEnabled && pageId && !this.highlightsPage[pageId]) {
                    const {data} = await this.getHighlightsInstagram({id: pageId})
                    this.$set(this.highlightsPage, pageId, data && data.highlights ? data.highlights : [])
                }
            },

            toggleMuteSound() {
                this.mutedSound = !this.mutedSound;
                const audio = this.$refs.audio;
                if (audio) {
                    audio.volume = this.mutedSound ? 0 : 0.5;
                }
            },

            setMuteSound(bool) {
                this.mutedSound = bool;
                const audio = this.$refs.audio;
                if (audio) {
                    audio.volume = this.mutedSound ? 0 : 0.5;
                }
            },


            videoCheckLoop(e) {
                //s'assurer que la musique boucle en même temps que la vidéo
                if (e.target.currentTime <= 0.2) {
                    this.restartMusic()
                }

                if (e.target.currentTime >= 60) {
                    e.target.currentTime = 0
                }
            },

            setStartMusic(e) {
                //positionner la musique au bon endroit
                const audio = e ? e.target : this.$refs.audio;
                if (this.musicSticker) {
                    const currentTimeVideo = this.$refs.video ? this.$refs.video.currentTime : 0;
                    audio.currentTime = this.musicSticker.data.start/1000 + currentTimeVideo;
                } 
            },

            restartMusic(e) {
                //positionner la musique au bon endroit
                const audio = e ? e.target : this.$refs.audio;
                if (this.musicSticker) {
                    audio.currentTime = this.musicSticker.data.start/1000;
                } 
            },

            checkTimeMusic(e) {
                //s'assurer que la musique boucle bien sur le bon segment
                if (e.target && this.musicSticker) {
                    if (e.target.currentTime < this.musicSticker.data.start/1000) {
                        this.restartMusic()
                    }

                    if (this.musicSticker.data.duration) {
                        const endTime = (this.musicSticker.data.start + this.musicSticker.data.duration)/1000;
                        if (!this.$refs.video && e.target.currentTime >= endTime) {
                            this.restartMusic()
                        }
                    }
                }
            }
            
        },

        watch: {
            ['pageSelected.id']: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.loadHighlights(this.pageSelected.id)
                }
            },
        },

        computed: {

            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            dataInstagramDefault() {
                return this.$store.getters['postCreator/dataStoryMakerDefault'];
            },
            musicSticker() {
                return this.storySelected.stickers.getByType('music')?.[0]
            },

            backgroundFile() {
                return this.storySelected.background.file
            },

            pagesSelectedIncludeConciergerie() {
                return this.pagesSelected.filter(page => page.network == 'instagram' && page.story_config && page.story_config.created).length
            },
         
            
          
            
        },

        beforeDestroy () {
            EventBus.$off('storyMaker-setOverlay', this.setOverlay);
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



